module.exports = __webpack_public_path__ + "static/media/screenshot-1.d9033834.png";